module.exports = __webpack_public_path__ + "img/home-customs.7d55a26d.svg";